module.exports = __webpack_public_path__ + "media/images/bg_report-4e394294bce41acfc8563b0551e04543.svg";